var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPlayFill(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    overflow: "visible",
    style: {
      display: "block"
    },
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "mingcute:play-fill"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.669 4.76C5.69601 4.53294 5.77561 4.31531 5.90148 4.12441C6.02735 3.93352 6.19602 3.77462 6.39408 3.66034C6.59214 3.54607 6.81413 3.47958 7.04239 3.46615C7.27066 3.45273 7.49891 3.49274 7.709 3.583C8.771 4.036 11.151 5.115 14.171 6.859C17.192 8.603 19.317 10.125 20.24 10.817C21.028 11.407 21.03 12.58 20.241 13.172C19.327 13.859 17.228 15.363 14.171 17.128C11.111 18.894 8.759 19.96 7.707 20.408C7.49706 20.4985 7.26887 20.5387 7.04063 20.5254C6.81239 20.5121 6.59042 20.4456 6.39244 20.3313C6.19446 20.2169 6.02594 20.0579 5.90033 19.8669C5.77473 19.6758 5.69551 19.4581 5.669 19.231C5.531 18.09 5.273 15.497 5.273 11.995C5.273 8.495 5.53 5.903 5.669 4.76Z",
    fill: "white"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlayFill);
export default __webpack_public_path__ + "static/media/play-fill.dbe36eae964e7046a1c7080adc55f622.svg";
export { ForwardRef as ReactComponent };